import {SliceStatus} from './Redux.types'
import {UsersAndGroupsLastEvaluatedKeyTypes} from './Settings.types'

export type ImportUsersType = {
  message: string
  Items: UserEntity[]
  LastEvaluatedKey?: UsersAndGroupsLastEvaluatedKeyTypes
  status: SliceStatus
  hasMore?: boolean
}

export interface UserEntity {
  emailId: string
  name: string
  groupNames: string[]
}

export type ImportGroupsType = {
  message?: string
  Items: GroupEntity[]
  LastEvaluatedKey?: UsersAndGroupsLastEvaluatedKeyTypes
  status: SliceStatus
  hasMore?: boolean
}

export interface GroupEntity {
  membersCount: string
  emailId: string
  name: string
}

export interface ImportCallbackParams {
  status: USER_IMPORT_STATUS
  expected_domain?: string
  current_domain?: string
  import_url?: string
}

export enum USER_IMPORT_STATUS {
  InProgress = 'IN_PROGRESS',
  AccessDenied = 'ACCESS_DENIED',
  Failure = 'FAILURE',
}
